// extracted by mini-css-extract-plugin
module.exports = {"form":"ModalSign_form__3dhZX","signatureButtonsRight":"ModalSign_signatureButtonsRight__2wptq"};